import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-1 inline-flex flex-col justify-center" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M5 15l7-7 7 7"
}, null, -1)
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_6 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M7 10l5-5 5 5M7 14l5 5 5-5"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("span", _hoisted_1, [
    (_ctx.direction === 'asc')
      ? (_openBlock(), _createBlock("svg", _hoisted_2, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.direction === 'desc')
      ? (_openBlock(), _createBlock("svg", _hoisted_4, [
          _hoisted_5
        ]))
      : _createCommentVNode("", true),
    (_ctx.direction === '')
      ? (_openBlock(), _createBlock("svg", _hoisted_6, [
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ]))
}